<template>
  <div>
    <template v-if="preloader">
      <client-only>
        <v-lottie position="fixed" />
      </client-only>
    </template>
    <div class="display-flex flex-column justify-content-center align-items-center gap-20">
      <div class="display-flex justify-content-center align-items-center" data-testid="forgot-password-image">
        <nuxt-img
          src="/assets/images/svg/ic_forgot-reset-password.svg"
          alt="Airalo"
          :height="`125px`"
          :width="`125px`"
          class="w-auto"
          loading="lazy"
        />
      </div>

      <div class="display-flex justify-content-center">
        <p class="typo-p color-text-secondary text-center mb-0">
          {{ $t('scenes.verify.reset.password.description') }}
        </p>
      </div>

      <form @submit.prevent="" autocomplete="off" class="w-100">
        <div class="display-flex flex-column jusify-content-center align-items-center gap-35">
          <div class="w-100">
            <div class="general-input">
              <div
                :class="[
                  `field field-text`,
                  {
                    'field-invalid': errors.has('email'),
                    'field-filled': emailForReset.length,
                  },
                ]"
              >
                <input
                  id="email"
                  type="text"
                  v-model="emailForReset"
                  name="email"
                  v-validate="'required|email'"
                  data-vv-validate-on="blur"
                  data-testid="email-input"
                  @focus="$validator.errors.remove('email')"
                  :class="[
                    'input',
                    {
                      invalid: errors.has('email'),
                      empty: emailForReset.length <= 0,
                    },
                  ]"
                  :data-vv-as="$t('placeholders.text.field.email')"
                  autocomplete="on"
                />
                <label for="email">
                  {{ $t('placeholders.text.field.email') }}
                </label>
              </div>
              <div class="field-error" v-if="errors.first('email')">
                <p>
                  {{ errors.first('email') }}
                </p>
              </div>
            </div>
          </div>

          <div class="w-100 mt-5">
            <button
              class="button button-secondary block btn-primary-hv"
              :disabled="preloader"
              @click.prevent="validate()"
              data-testid="continue-button"
            >
              {{ $t('global.continue') }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        emailForReset: '',
        preloader: false,
      }
    },

    methods: {
      goHome() {
        this.$router.push(this.localePath('/'))
      },

      validate() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.resetPassword()
          }
        })
      },
      async resetPassword() {
        this.preloader = true

        this.$store.commit('set_auth_dialogs_email', this.emailForReset)

        if (window.localStorage) {
          window.localStorage.setItem('set_auth_dialogs_email', this.emailForReset)
        }

        try {
          await this.$axios.post('/auth/forgot', {
            email: this.emailForReset,
          })

          this.$utils.sendEvent('forgetPassword', { method: 'form' })

          this.$router.push(
            this.localePath({
              name: 'verify-index-respass-2',
              query: {
                email: this.emailForReset,
              },
            })
          )

          this.preloader = false
        } catch (error) {
          this.preloader = false

          this.$bvToast.toast(error.response.data.message, {
            title: this.$t('global.error.title'),
            variant: 'danger',
            solid: true,
          })
        }
      },
    },
  }
</script>
